import Plyr from "plyr";

function modalClose(el) {
    el?.classList.add('hidden');
}

const videoModal = () => {

    const playVideo = document.querySelector('.play_map');
    const modalVideo = document.querySelector('.modal-video');
    const close = document.querySelector('.modal-video .btn-close');
    const video = document.querySelector('.modal-video .js-video');

    playVideo && playVideo.addEventListener('click', (e) => {
        e.preventDefault();
        modalVideo.classList.remove('hidden');
        video.play();
    });

    
   close && close.addEventListener('click', (e) => {
        e.preventDefault();
        modalClose(modalVideo);
        video.pause();
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !modal.classList.contains("hidden")) {
          modalClose(modal);
        }
    });

}

export default videoModal;